import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

function getRootElement(): HTMLElement {
	const rootElement = document.getElementById("root");
	if (!rootElement) {
		throw new Error("Root element #root not found");
	}
	return rootElement;
}

function registerOfflineServiceWorker(): void {
	if (!("serviceWorker" in navigator)) return;

	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/sw.js").catch(() => {
			// Registration can fail on non-secure origins other than localhost.
		});
	});
}

registerOfflineServiceWorker();

createRoot(getRootElement()).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
